(function () {
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	function init() {
	var section = document.querySelector('.p360-demo');
	if (!section) {
		return;
	}

	var CHAPTERS = [
		{ id: 0, title: 'An HCP has a question.', start: 0 },
		{ id: 1, title: 'They answer back.', start: 130 },
		{ id: 2, title: 'The answer is remembered.', start: 265 },
		{ id: 3, title: 'Compliance is built in.', start: 400 },
	];
	var MARKERS = [];

	var video = document.getElementById('vpVideo');
	var frame = document.getElementById('vpFrame');
	var playOverlay = document.getElementById('vpPlayOverlay');
	var playPauseBtn = document.getElementById('vpPlayPause');
	var back10Btn = document.getElementById('vpBack10');
	var fwd10Btn = document.getElementById('vpFwd10');
	var timeLabel = document.getElementById('vpTime');
	var chapterLabel = document.getElementById('vpChapterLabel');
	var muteBtn = document.getElementById('vpMute');
	var volumeSlider = document.getElementById('vpVolume');
	var fullscreenBtn = document.getElementById('vpFullscreen');
	var seekWrap = document.getElementById('vpSeekWrap');
	var track = document.getElementById('vpTrack');
	var bufferedEl = document.getElementById('vpBuffered');
	var playedEl = document.getElementById('vpPlayed');
	var playheadEl = document.getElementById('vpPlayhead');
	var tooltip = document.getElementById('vpTooltip');
	var chapterListEl = document.getElementById('vpChapterList');

	if (!video) {
		return;
	}

	var duration = 0;
	var scrubbing = false;
	var hideTimer = null;

	var ICON_PLAY = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>';
	var ICON_PAUSE = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M6 5h4v14H6zM14 5h4v14h-4z"/></svg>';
	var ICON_VOL = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/></svg>';
	var ICON_MUTE = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M16.5 12A4.5 4.5 0 0014 7.97v2.21l2.45 2.45c.03-.2.05-.42.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/></svg>';
	var ICON_FS = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg>';
	var ICON_FS_EXIT = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"/></svg>';

	function formatTime(t) {
		if (!isFinite(t) || t < 0) t = 0;
		var m = Math.floor(t / 60);
		var s = Math.floor(t % 60);
		return m + ':' + (s < 10 ? '0' + s : s);
	}

	function pct(t) { return duration ? (t / duration) * 100 : 0; }

	function currentChapterIndex(current) {
		var idx = 0;
		for (var i = 0; i < CHAPTERS.length; i++) {
			if (current >= CHAPTERS[i].start) idx = i;
		}
		return idx;
	}

	function buildChapterList() {
		chapterListEl.innerHTML = '';
		CHAPTERS.forEach(function (c, i) {
			var end = CHAPTERS[i + 1] ? CHAPTERS[i + 1].start : duration;
			var btn = document.createElement('button');
			btn.className = 'vp-chapter-item';
			btn.dataset.index = i;
			btn.innerHTML =
				'<svg class="chevron" viewBox="0 0 24 24" fill="currentColor"><path d="M9.29 6.71a1 1 0 000 1.41L13.17 12l-3.88 3.88a1 1 0 101.41 1.41l4.59-4.59a1 1 0 000-1.41L10.7 6.71a1 1 0 00-1.41 0z"/></svg>' +
				'<span class="ch-title">' + c.title + '</span>' +
				'<span class="ch-range">' + formatTime(c.start) + '\u2013' + formatTime(end) + '</span>';
			btn.addEventListener('click', function () { seekTo(c.start); });
			chapterListEl.appendChild(btn);
		});
	}

	function buildDividersAndMarkers() {
		track.querySelectorAll('.vp-chapter-div, .vp-marker-tick').forEach(function (el) { el.remove(); });

		CHAPTERS.forEach(function (c) {
			if (c.start <= 0) return;
			var div = document.createElement('div');
			div.className = 'vp-chapter-div';
			div.style.left = pct(c.start) + '%';
			track.appendChild(div);
		});

		MARKERS.forEach(function (m) {
			var tick = document.createElement('div');
			tick.className = 'vp-marker-tick';
			tick.style.left = pct(m.time) + '%';
			tick.dataset.time = m.time;
			tick.dataset.label = m.label;
			tick.addEventListener('mouseenter', function () {
				showTooltip(m.time, pct(m.time));
			});
			track.appendChild(tick);
		});
	}

	function updateChapterUI(current) {
		var idx = currentChapterIndex(current);
		chapterLabel.textContent = 'Chapter ' + (idx + 1) + ' \u00B7 ' + CHAPTERS[idx].title;
		var items = chapterListEl.querySelectorAll('.vp-chapter-item');
		items.forEach(function (item, i) {
			item.classList.toggle('active', i === idx);
		});
	}

	function render() {
		var current = video.currentTime || 0;
		playedEl.style.width = pct(current) + '%';
		playheadEl.style.left = pct(current) + '%';
		timeLabel.textContent = formatTime(current) + ' / ' + formatTime(duration);
		updateChapterUI(current);

		if (video.buffered && video.buffered.length) {
			var bufEnd = video.buffered.end(video.buffered.length - 1);
			bufferedEl.style.width = pct(bufEnd) + '%';
		}
	}

	function togglePlay() {
		if (video.paused) video.play();
		else video.pause();
	}

	function seekTo(t) {
		if (!duration) return;
		var clamped = Math.min(Math.max(t, 0), duration);
		video.currentTime = clamped;
		render();
	}

	function skip(delta) { seekTo(video.currentTime + delta); }

	video.addEventListener('loadedmetadata', function () {
		duration = video.duration || 0;
		buildChapterList();
		buildDividersAndMarkers();
		render();
	});
	video.addEventListener('timeupdate', render);
	video.addEventListener('progress', render);
	video.addEventListener('play', function () {
		playOverlay.style.display = 'none';
		playPauseBtn.innerHTML = ICON_PAUSE;
		playPauseBtn.setAttribute('aria-label', 'Pause');
		wake();
	});
	video.addEventListener('pause', function () {
		playOverlay.style.display = 'flex';
		playPauseBtn.innerHTML = ICON_PLAY;
		playPauseBtn.setAttribute('aria-label', 'Play');
		frame.classList.remove('hide-controls');
		clearTimeout(hideTimer);
	});
	video.addEventListener('ended', function () {
		playOverlay.style.display = 'flex';
	});

	video.addEventListener('click', togglePlay);
	playOverlay.addEventListener('click', togglePlay);
	playPauseBtn.addEventListener('click', togglePlay);
	back10Btn.addEventListener('click', function () { skip(-10); });
	fwd10Btn.addEventListener('click', function () { skip(10); });

	function posToTime(clientX) {
		var rect = track.getBoundingClientRect();
		var ratio = Math.min(Math.max((clientX - rect.left) / rect.width, 0), 1);
		return ratio * duration;
	}

	function showTooltip(time, percent) {
		tooltip.style.display = 'block';
		tooltip.style.left = percent + '%';
		var nearMarker = MARKERS.find(function (m) { return Math.abs(m.time - time) < 0.4; });
		tooltip.innerHTML = formatTime(time) + (nearMarker ? '<span class="vp-tooltip-marker">' + nearMarker.label + '</span>' : '');
	}

	function hideTooltip() { tooltip.style.display = 'none'; }

	seekWrap.addEventListener('mousemove', function (e) {
		var t = posToTime(e.clientX);
		var p = duration ? (t / duration) * 100 : 0;
		showTooltip(t, p);
		if (scrubbing) seekTo(t);
	});
	seekWrap.addEventListener('mouseleave', function () {
		if (!scrubbing) hideTooltip();
	});
	seekWrap.addEventListener('mousedown', function (e) {
		scrubbing = true;
		seekTo(posToTime(e.clientX));
	});
	window.addEventListener('mousemove', function (e) {
		if (scrubbing) seekTo(posToTime(e.clientX));
	});
	window.addEventListener('mouseup', function () {
		scrubbing = false;
	});

	muteBtn.addEventListener('click', function () {
		video.muted = !video.muted;
		muteBtn.innerHTML = video.muted || video.volume === 0 ? ICON_MUTE : ICON_VOL;
	});
	volumeSlider.addEventListener('input', function (e) {
		var val = parseFloat(e.target.value);
		video.volume = val;
		video.muted = val === 0;
		muteBtn.innerHTML = video.muted || val === 0 ? ICON_MUTE : ICON_VOL;
	});

	fullscreenBtn.addEventListener('click', function () {
		if (!document.fullscreenElement) {
			frame.requestFullscreen && frame.requestFullscreen();
		} else {
			document.exitFullscreen && document.exitFullscreen();
		}
	});
	document.addEventListener('fullscreenchange', function () {
		fullscreenBtn.innerHTML = document.fullscreenElement ? ICON_FS_EXIT : ICON_FS;
	});

	function wake() {
		frame.classList.remove('hide-controls');
		clearTimeout(hideTimer);
		hideTimer = setTimeout(function () {
			if (!video.paused) frame.classList.add('hide-controls');
		}, 2500);
	}
	frame.addEventListener('mousemove', wake);
	frame.addEventListener('mouseleave', function () {
		if (!video.paused) frame.classList.add('hide-controls');
	});

	frame.tabIndex = 0;
	frame.addEventListener('keydown', function (e) {
		if (e.code === 'Space') { e.preventDefault(); togglePlay(); }
		else if (e.code === 'ArrowRight') { skip(5); }
		else if (e.code === 'ArrowLeft') { skip(-5); }
	});


	var lightbox = section.querySelector('[data-p360-demo-lightbox]');
	var lastFocused = null;
	var pendingChapter = 0;

	function openLightbox(chapterIndex) {
		pendingChapter = chapterIndex || 0;
		lastFocused = document.activeElement;
		lightbox.removeAttribute('hidden');
		document.body.classList.add('p360-demo-lock');
		if (frame) frame.focus();

		if (!duration) {
			video.load();
		}

		requestAnimationFrame(function () {
			if (duration && CHAPTERS[pendingChapter]) {
				seekTo(CHAPTERS[pendingChapter].start);
			}
			video.play();
		});
	}

	function closeLightbox() {
		lightbox.setAttribute('hidden', true);
		document.body.classList.remove('p360-demo-lock');
		video.pause();
		if (lastFocused && lastFocused.focus) {
			lastFocused.focus();
		}
	}

	section.querySelectorAll('[data-p360-demo-open]').forEach(function (el) {
		el.addEventListener('click', function () {
			openLightbox(parseInt(el.getAttribute('data-chapter'), 10) || 0);
		});
	});
	lightbox.querySelectorAll('[data-p360-demo-close]').forEach(function (el) {
		el.addEventListener('click', closeLightbox);
	});
	document.addEventListener('keydown', function (e) {
		if (e.key === 'Escape' && !lightbox.hasAttribute('hidden')) {
			closeLightbox();
		}
	});
	}
})();